module.exports = __webpack_public_path__ + "static/media/bindOutlook1.a9143fc7.png";